import SundowningImage from '../../assets/albums/covers/sundowning.jpeg';
import VinylAlbum from './VinylAlbum';

function Sundowning({ albumRef, delay, onClick, isPlaying }) {
  return (
    <VinylAlbum
      image={SundowningImage}
      alt="Sundowning"
      isPlaying={isPlaying}
      onClick={onClick}
      albumRef={albumRef}
      delay={delay}
    />
  );
}

export default Sundowning;